import { FC } from 'react';
import classnames from 'classnames';
import { LayOutPageItemEnum, LayOutPageDetailProps } from './interface';

const LayOutPageDetail: FC<LayOutPageDetailProps> = props => {
  const { children, className, isHide, ...restProps } = props;
  const classes = classnames('yb-layout-page-detail', className, {
    hide: isHide,
  });
  return (
    <div {...restProps} className={classes}>
      {children}
    </div>
  );
};

LayOutPageDetail.defaultProps = {
  isHide: true,
};

LayOutPageDetail.displayName = LayOutPageItemEnum.Detail;

export default LayOutPageDetail;
